import { Component, OnInit,Input ,Output,EventEmitter} from '@angular/core';
import * as moment from 'moment';
import { CommonapiService } from '../../../Service/Commonapi.service';
import { PlanCalendarService } from 'src/app/Module/Core/PlanCalendar/PlanCalendar.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-CTPlanRejection',
  templateUrl: './CTPlanRejection.component.html'
})
export class CTPlanRejectionComponent implements OnInit {

  @Input() state: any; @Output() CallParent: EventEmitter<any> = new EventEmitter();
  rejectionreasonList=[];@Input() data: any;
  todayDate: any = new Date();
  constructor( private Winfoapi: CommonapiService,private planCalendarapi: PlanCalendarService) { }


  ngOnInit() {
  }
  show=false;
  Show(state){
    this.state=state;
    this.state.rejectionreason.iserr = false;
    this.state.rejectionreason.err_txt = "";
    this.state.rejectionreason.value = "0";
    this.state.rejectionreasonComments.value = "";
    this.show=true;
  }

  planRejectionReasonCancel()
  {
    this.state.rejectionreasonComments.iserr = false; 
    this.state.rejectionreasonComments.err_txt = "";
    this.Callparentfunc(0);
    this.show=false;
  }
  Callparentfunc(status,data=''){
    this.CallParent.emit({status:status,data:data});
  }
  async planRejectionReasonYes()
  {
    let isvalid = true;   

    if ((this.state.rejectionreason.value) == "0") {

      this.state.rejectionreason.iserr = true; 
      this.state.rejectionreason.err_txt = "Enter reason";
      isvalid = false;      
      
    }else if((this.state.rejectionreason.value) != "0")
    {
      this.state.rejectionreason.iserr = false; 
      this.state.rejectionreason.err_txt = "";
    }


  let otherRejectReasonID = '-1';
  this.rejectionreasonList.map((x, index) => {
          
          if(x.reason == 'Other' || x.reason == 'other')
          {
			      otherRejectReasonID = x.reason_id;            
            
          }
   })
   
   if((this.state.rejectionreason.value == otherRejectReasonID) && this.state.rejectionreasonComments.value == '')
   {
		  this.state.rejectionreasonComments.iserr = true; 
      this.state.rejectionreasonComments.err_txt = "Enter reason comment";
      isvalid = false;    
   }
   else
   {
		  this.state.rejectionreasonComments.iserr = false; 
      this.state.rejectionreasonComments.err_txt = "";
   }

   

    if (isvalid) {      
     // $('#divPlanRejectionReasonPopup').removeClass('pop_active_card');         
     

      console.log('selected obj', this.data);

      const format1 = "YYYY-MM-DD";
      let calenderDate = moment(this.data.calendar_date).format(format1)
      
      let currentDate = new Date();
      const currentDateFormat1 = "YYYY-MM-DD";//"DD MMMM YYYY";
      var formattedCurrentDate = moment(currentDate).format(currentDateFormat1);
      var title = "\""+ this.data.customer_name  +  "\"" + " accompany has been rejected by User";
      var postdata = {
        "planId" :  this.data.plan_id,    
        "calendarDate" :  calenderDate,
        "customerId" :  this.data.customer_id,        
        "movedToDate" :  "",
        "planAlongStatusSub" :  "2",
        "reasonId" :  "",
        "reason" :  "",
        "title" :  title,
        "data" :  "",
        "isRead" :  "",
        "url" :  environment.angularurl+"#/user/planlist",
        "create_user" : this.data.is_create_user,
        "presentMonth": this.data.presentMonth,
        "presentYear": this.data.presentYear,
        "preNextFlag": this.data.preNextFlag,
        "latitude": this.data.mainlatitude+"",
        "longitude": this.data.mainlongitude+"",     
        "startDate": this.data.startDate,
      }
      console.log("postdata",postdata);
      //return false;
      this.planCalendarapi.api.loader.startLoading();
      this.planCalendarapi.PlanListEventGetUpdateV1(postdata, false).then(data => {
        if (data && data!= undefined && data != '[]') {
          if (data.planEventUpdateResponse.plan_id > 0) {
            this.state.rejectionreason.iserr = false;
            this.state.rejectionreason.err_txt = "";
            this.state.rejectionreason.value = "0";
            this.state.rejectionreasonComments.value = "";         
            this.show = false;
            // this.Callparentfunc(1,data.planListViewResponse[0])
            this.Callparentfunc(1,data);
           // this.planRejectionReasonCancel();
            // this.loopcount = 0;
            // this.state.location = ""; // each time location will be set in state to aviod mismatch lat long
            // this.getLocation();
            // this.Check();
          }   
        }
        this.planCalendarapi.api.loader.stopLoading();
      })
    }
  }
  drprejectionreason_Click()
  {
    if(this.state.rejectionreason.value == '' || this.state.rejectionreason.value == '0')
    {
      
      
    }
    else
    {
      this.state.rejectionreason.iserr = false; 
      this.state.rejectionreason.err_txt = "";
    }
  
    this.state.rejectionreasonComments.iserr = false; 
    this.state.rejectionreasonComments.err_txt = "";
  
  }
}
